import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '../button/button.module';
import {
  NgbPaginationFirst,
  NgbPaginationLast,
  NgbPaginationNext,
  NgbPaginationNumber,
  NgbPaginationPrevious,
  NgbPaginationText,
  PaginationComponent,
} from './pagination.component';

@NgModule({
  imports: [CommonModule, ButtonModule],
  declarations: [
    PaginationComponent,
    NgbPaginationNext,
    NgbPaginationNumber,
    NgbPaginationPrevious,
    NgbPaginationFirst,
    NgbPaginationLast,
    NgbPaginationText,
  ],
  exports: [PaginationComponent, NgbPaginationText],
})
export class PaginationModule {}
